import { useEffect, type Dispatch, type SetStateAction } from 'react'
import { getLatestSearchSessionId } from '@/lib/search-session-history'
import type { SearchSessionSummary } from '@/hooks/use-search-sessions'

export type UseAutoLatestSearchSessionOptions = {
  sessions: SearchSessionSummary[]
  sessionsLoading: boolean
  isSearching: boolean
  liveSessionId?: string | null
  setSelectedSessionId: Dispatch<SetStateAction<string | null>>
}

export function useAutoLatestSearchSession({
  sessions,
  sessionsLoading,
  isSearching,
  liveSessionId,
  setSelectedSessionId,
}: UseAutoLatestSearchSessionOptions) {
  useEffect(() => {
    if (!liveSessionId) return
    setSelectedSessionId(null)
  }, [liveSessionId, setSelectedSessionId])

  useEffect(() => {
    if (sessionsLoading || isSearching || liveSessionId) return

    const latestSessionId = getLatestSearchSessionId(sessions)
    setSelectedSessionId((current) =>
      latestSessionId === current ? current : latestSessionId,
    )
  }, [sessions, sessionsLoading, isSearching, liveSessionId, setSelectedSessionId])
}
